import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksVendorFields.ContactInformationSection', {
    header: 'CONTACT INFORMATION',
    phone: 'Phone',
    fax: 'Fax',
    mobile: 'Mobile',
    email: 'Email',
    website: 'Website',
});
